import React from "react";
import { Input, Form, Typography } from "antd";
interface Props {
  userData?: any;
  form: any;
}

export const ConfirmEvent: React.FC<Props> = ({
  userData,
  form,
}): React.ReactElement => {
  return (
    <div>
      <Typography className="font-bold text-center mb-[30px]">{`Registration Form for check in`}</Typography>
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        className="w-full"
        fields={[
          {
            name: ["fullName"],
            value: `${userData?.fullName}`,
          },
          {
            name: ["numberId"],
            value: userData?.numberId,
          },
          {
            name: ["phone"],
            value: userData?.phone,
          },
          {
            name: ["position"],
            value: userData?.position,
          },
          {
            name: ["department"],
            value: userData?.department,
          },
          {
            name: ["email"],
            value: userData?.email,
          },
          {
            name: ["company"],
            value: userData?.company,
          },
        ]}
      >
        <Form.Item
          label={"Name-Surname"}
          name={"fullName"}
          rules={[
            {
              required: true,
              message: "Please fill in your name surname!",
            },
          ]}
        >
          <Input placeholder="Text" />
        </Form.Item>
        <Form.Item
          label={"Company"}
          name={"company"}
          rules={[
            {
              required: true,
              message: "Please fill in your company!",
            },
          ]}
        >
          <Input placeholder="Text" />
        </Form.Item>
        <Form.Item
          label={"Position"}
          name={"position"}
          rules={[
            {
              required: true,
              message: "Please fill in your position!",
            },
          ]}
        >
          <Input placeholder="Text" />
        </Form.Item>
        <Form.Item
          label={"Business Email"}
          name={"email"}
          rules={[
            {
              required: true,
              message: "Please fill in your email!",
            },
          ]}
        >
          <Input placeholder="example@email.com" type="email" />
        </Form.Item>
        <Form.Item
          label={"Phone number"}
          name={"phone"}
          rules={[
            {
              required: true,
              message: "Please fill in your phone!",
            },
          ]}
        >
          <Input placeholder="0XX-XXX-XXXX" />
        </Form.Item>
      </Form>
    </div>
  );
};
